import React from "react"
import { Trans } from "react-i18next"
import { Callout, Link } from "@node-space/ui-components"

export const BeneficiaryDeprecationCallout = () => {
  return (
    <Callout variant="warning">
      <p>
        <Trans
          i18nKey="wallets.fiatSend.beneficiaryLeavingSoonDescription"
          components={{
            boldText: <span className="font-semibold" />,
            articleLink: <Link href={process.env.BENEFICIARY_MIGRATION_ARTICLE_URL ?? ''} target="_blank">{''}</Link>,
          }}
        />
      </p>
    </Callout>
  )
}